import { createContext, Dispatch, SetStateAction } from "react";

const mobileMenuIsActiveValue: boolean = false;
const setMobileMenuIsActiveValue: Dispatch<SetStateAction<boolean>> = () => {};

export default createContext({
 mobileMenuIsActive: mobileMenuIsActiveValue,
 setMobileMenuIsActive: setMobileMenuIsActiveValue,
});
